import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppSelector } from 'app/config/store';
import { getPartsByReview } from 'app/entities/part/part.reducer';
import React, { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { useDispatch } from 'react-redux';
import { FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import PartModal from './PartModal';
import './part.scss';

type PartSelectionModalProps = {
  modalOpen: boolean;
  setModalOpen: any;
  maintenanceReviewId: number;
};

export const PartsViewModal = React.memo(({ modalOpen, setModalOpen, maintenanceReviewId }: PartSelectionModalProps) => {
  const dispatch = useDispatch();
  const [selectedPart, setSelectedPart] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const parts = useAppSelector(state => state.part.entities);
  const filteredParts = parts.filter(
    part => part.name.toLowerCase().includes(searchTerm.toLowerCase()) || part.code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    dispatch(getPartsByReview(maintenanceReviewId));
  }, [dispatch]);

  const toggleModal = () => {
    setSearchTerm('');
    setModalOpen((prev: boolean) => !prev);
  };

  return (
    <Fragment>
      {selectedPart && <PartModal part={selectedPart} toggle={() => setSelectedPart(null)} isOpen={!!selectedPart} />}
      <Modal isOpen={modalOpen} toggle={toggleModal} zIndex={99999}>
        <ModalHeader toggle={toggleModal}>{translate('fleetSenseApp.maintenanceReview.part')}</ModalHeader>
        <ModalBody style={{ maxHeight: '50vh', overflow: 'auto' }}>
          <div className="d-flex align-items-center justify-content-end">
            <FormGroup>
              <Input
                bsSize="sm"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                type="text"
                name="search"
                id="search"
                placeholder="Nome ou Código"
              />
              {!searchTerm ? (
                <FontAwesomeIcon icon={faSearch} style={{ position: 'absolute', top: '25px', right: '25px' }} color={'#2cb4b4'} />
              ) : (
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  style={{ position: 'absolute', top: '18px', right: '25px' }}
                  onClick={() => setSearchTerm('')}
                >
                  <span aria-hidden="true">×</span>
                </button>
              )}
            </FormGroup>
          </div>
          {filteredParts.map(part => (
            <div key={part.id} className="container-modal-update">
              <FormGroup check title={part.code ? `${part.name} - ${part.code}` : part.name}>
                <Label check className="not-hover">
                  <span className="not-hover">{part.name + (part.code && ' -')}</span>
                  {part.code && <small className="not-hover">{part.code}</small>}
                </Label>
                <FontAwesomeIcon icon="eye" onClick={() => setSelectedPart(part)} />{' '}
              </FormGroup>
            </div>
          ))}
        </ModalBody>
      </Modal>
    </Fragment>
  );
});
